import { useEffect, useRef } from "react";
import { SalesPage } from "./components/SalesPage";
export function App() {
  const pixelInitialized = useRef(false);
  useEffect(() => {
    // Meta Pixel Code
    if (typeof window === "undefined" || typeof document === "undefined") {
      return;
    }
    // Prevent duplicate initialization using both ref and global flag
    // Global flag persists across component remounts (e.g., React Strict Mode)
    if (pixelInitialized.current || (window as any).__fbPixelInitialized) {
      return;
    }

    // Mark as initialized immediately to prevent race conditions
    pixelInitialized.current = true;
    (window as any).__fbPixelInitialized = true;
    // Load Meta Pixel script
    (function (f: any, b: any, e: string, v: string) {
      if (f.fbq) return;
      const n: any = f.fbq = function () {
        // eslint-disable-next-line prefer-rest-params
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = "2.0";
      n.queue = [];
      const t = b.createElement(e);
      t.async = !0;
      t.src = v;
      const s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
    (window as any).fbq("init", "1423074459182335");
    (window as any).fbq("track", "PageView");
    console.log("✅ Meta Pixel loaded - ID: 1423074459182335");
    console.log("✅ PageView tracked");
    // Lead event when clicking checkout/purchase buttons
    const checkoutButtons = document.querySelectorAll('.checkout-btn, .cta-button, a[href*="hotmart"], a[href*="checkout"], button[data-checkout], button:has(.lucide-download)');
    const handleCheckoutClick = () => {
      if (typeof (window as any).fbq === "function") {
        (window as any).fbq("track", "Lead");
        console.log("✅ Lead tracked");
      }
    };
    checkoutButtons.forEach(btn => {
      btn.addEventListener("click", handleCheckoutClick);
    });
    // Cleanup event listeners on unmount
    return () => {
      checkoutButtons.forEach(btn => {
        btn.removeEventListener("click", handleCheckoutClick);
      });
    };
  }, []);
  return <div className="w-full min-h-screen bg-cream-50" data-id="element-0">
      <SalesPage data-id="element-1" />

      {/* Meta Pixel noscript fallback */}
      <noscript data-id="element-2">
        <img height="1" width="1" style={{
        display: "none"
      }} src="https://www.facebook.com/tr?id=1423074459182335&ev=PageView&noscript=1" alt="" data-id="element-3" />
      </noscript>
    </div>;
}